import { useEffect, useState, useCallback, useContext, useRef, forwardRef } from 'react';
import { LoginContext } from "../AuthContext/LoginContext";
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-buttons-dt/js/buttons.dataTables.js';
import 'jszip/dist/jszip.min.js';
import 'pdfmake/build/pdfmake.min.js';
import 'pdfmake/build/vfs_fonts.js';
import Icon from './child/ComplaintIcon';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import 'react-loading-skeleton/dist/skeleton.css';
import { statusWithLevel } from '../utils/escalation';
import { statusLabel } from '../utils/displayText';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from 'qrcode';
import './ComplaintDetailsModal.css';
import './ComplaintFilters.css';
import './ComplaintsList.css';
import ComplaintLocationSelect from './child/ComplaintLocationSelect';
import ComplaintAttachmentPreview from './child/ComplaintAttachmentPreview';
import { getMediaUrl } from '../utils/uploadService';

// Six status summary cards shown above the table (same look/labels/accents as
// the dashboard). `key` is the raw backend status; `label` is the display name.
const STATUS_SUMMARY_CARDS = [
    { key: 'Open', label: 'Open', accent: '#f59e0b', icon: 'mdi:lock-open-variant-outline' },
    { key: 'In Progress', label: 'Assigned', accent: '#6366f1', icon: 'mdi:account-clock-outline' },
    { key: 'Escalated', label: 'Escalated', accent: '#ef4444', icon: 'mdi:alert-octagon-outline' },
    { key: 'Closed', label: 'Closed', accent: '#0ea5e9', icon: 'mdi:check-decagram-outline' },
    { key: 'Reopened', label: 'Re-Open', accent: '#14b8a6', icon: 'mdi:lock-reset' },
    { key: 'Resolved', label: 'Resolved', accent: '#22c55e', icon: 'mdi:check-circle-outline' },
];

// `informativeOnly` renders this same list UI for the dedicated "Informative Calls"
// page: it fetches from /get-informative-complaints (informative:true only) and skips
// the status-name endpoint (which hides informative rows).
// Custom round "..." toggle for the row actions overflow menu (no default
// caret; styled to match the other circular action buttons).
const MoreActionsToggle = forwardRef(({ onClick, title }, ref) => (
    <button
        ref={ref}
        type="button"
        title={title}
        onClick={(e) => { e.preventDefault(); onClick(e); }}
        className="bg-neutral-200 bg-hover-neutral-300 text-secondary-light fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle border-0"
    >
        <Icon icon="mdi:dots-horizontal" className="icon text-xl" />
    </button>
));

const TableDataLayer = ({ initialStatus = '', embedded = false, informativeOnly = false }) => {
    const [complaints, setComplaints] = useState([]);
    const [filteredComplaints, setFilteredComplaints] = useState([]);
    const [showAllDetailsModal, setShowAllDetailsModal] = useState(false);
    const [selectedComplaint, setSelectedComplaint] = useState(null);
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const APP_BASE_URL = process.env.REACT_APP_URL;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const queryStatus = searchParams.get('status') || '';
    const queryForestZone = searchParams.get('forestZone') || '';
    const queryForestCircle = searchParams.get('forestCircle') || '';
    const queryForestDivision = searchParams.get('forestDivision') || '';
    // When rendered standalone (e.g. /complains/list) the user can pick a status
    // from a dropdown; the embedded modal keeps its fixed `initialStatus`.
    const [statusChoice, setStatusChoice] = useState(queryStatus);
    const statusFilter = initialStatus || statusChoice;
    const STATUS_OPTIONS = ['Open', 'In Progress', 'Closed', 'Probe Cases', 'Probe Reply Submitted', 'Escalated', 'Reopened', 'Cancelled', 'Resolved'];
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const { hasPermission } = useContext(LoginContext);
    const loggedInUserId = (() => {
        try {
            return JSON.parse(localStorage.getItem('user'))?._id || null;
        } catch {
            return null;
        }
    })();
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [qrDataUrl, setQrDataUrl] = useState('');
    
    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [sortingField, setSortingField] = useState('complaint_number');
    const [sortingOrder, setSortingOrder] = useState('DESC');
    
    // Date filter states
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    
    // Search state. `searchTerm` is what the user is typing; `debouncedSearch`
    // is the value actually sent to the server. Keeping them separate means
    // the fetch depends only on the committed search value, never on every
    // keystroke.
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    // Forest location filters (cascading: Zone -> Circle -> Division)
    const [forestZones, setForestZones] = useState([]);
    const [forestCircles, setForestCircles] = useState([]);
    const [forestDivisions, setForestDivisions] = useState([]);
    const [selectedZone, setSelectedZone] = useState(queryForestZone);
    const [selectedCircle, setSelectedCircle] = useState(queryForestCircle);
    const [selectedDivision, setSelectedDivision] = useState(queryForestDivision);

    // Debounce timer ref
    const searchTimeoutRef = useRef(null);

    // Monotonic request id. Every fetch bumps it and captures its own id;
    // when a response comes back we only apply it if it belongs to the most
    // recent request. This stops a slower, broader in-flight call (e.g. the
    // unfiltered load) from overwriting a newer, narrower one (e.g. status =
    // "Open") — the exact race that made a filtered view "load all" rows.
    const requestIdRef = useRef(0);

    const fetchComplaints = useCallback(async (searchValue = debouncedSearch) => {
        const requestId = ++requestIdRef.current;
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            
            const params = {
                perPage: perPage,
                pageNo: currentPage,
                sortingField: sortingField,
                sortingOrder: sortingOrder
            };
            
            // Add date filters if they exist
            if (fromDate) {
                params.from = fromDate;
            }
            if (toDate) {
                params.to = toDate;
            }
            if (statusFilter && statusFilter !== 'Total') {
                params.status = statusFilter;
            }

            // Forest location filters (cascading, sent as ObjectIds)
            if (selectedZone) {
                params.forestZone = selectedZone;
            }
            if (selectedCircle) {
                params.forestCircle = selectedCircle;
            }
            if (selectedDivision) {
                params.forestDivision = selectedDivision;
            }

            // Add search query only if it exists and search was triggered
            if (searchValue && searchValue.trim()) {
                params.searchQuery = searchValue.trim();
            }

            // Informative Calls page always uses the informative-only endpoint (the
            // status-name endpoint filters informative rows out). status still rides
            // along as a query param, so the status tabs keep working there too.
            const isStatusScoped = !informativeOnly && statusFilter && statusFilter !== 'Total';
            const response = isStatusScoped
                ? await axios.post(
                    `${API_BASE_URL}/backend/complaints/get-complaints-by-status-name`,
                    { status: statusFilter },
                    {
                        params,
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                )
                : await axios.get(`${API_BASE_URL}/backend/complaints/${informativeOnly ? 'get-informative-complaints' : 'get-all-complaints'}`, {
                    params,
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });


            // Drop the response if a newer request has since been issued.
            if (requestId !== requestIdRef.current) return;

            if (response.data.success || response.data.status) {
                const complaintsData = response.data.data || [];
                setComplaints(complaintsData);
                setFilteredComplaints(complaintsData);
                // Some endpoints (e.g. status-scoped list) return totalCount but not
                // totalPages — derive it so page numbers 2, 3… render either way.
                const _totalCount = response.data.totalCount || 0;
                const _totalPages = response.data.totalPages || Math.max(1, Math.ceil(_totalCount / perPage));
                setTotalPages(_totalPages);
                setTotalCount(_totalCount);
            } else {
                toast.error(response.data.message || "No data found.");
                setComplaints([]);
                setFilteredComplaints([]);
                setTotalPages(1);
                setTotalCount(0);
            }
        } catch (error) {
            if (requestId !== requestIdRef.current) return;
            console.error("Error fetching complaints:", error);
            // A 404 here just means "no complaints match these filters" — the
            // backend returns it for an empty result set, so show an empty
            // table instead of an alarming error toast.
            if (error.response?.status === 404) {
                setComplaints([]);
                setFilteredComplaints([]);
                setTotalPages(1);
                setTotalCount(0);
            } else {
                toast.error("Error fetching complaints.");
                setComplaints([]);
                setFilteredComplaints([]);
                setTotalPages(1);
                setTotalCount(0);
            }
        } finally {
            if (requestId === requestIdRef.current) setLoading(false);
        }
    }, [
        API_BASE_URL, 
        currentPage, 
        perPage, 
        sortingField, 
        sortingOrder, 
        fromDate,
        toDate,
        debouncedSearch,  // committed search value (not raw keystrokes)
        statusFilter,
        selectedZone,
        selectedCircle,
        selectedDivision,
        informativeOnly
    ]);

    // Reset to the first page whenever the status filter changes.
    useEffect(() => {
        setCurrentPage(1);
    }, [statusFilter]);

    // Single source of truth for fetching. `fetchComplaints` is memoised on
    // every value that affects the query (page, sorting, dates, status,
    // location and the committed search), so this effect re-runs exactly when
    // one of those changes — no eslint-disable, no stale closure, and the
    // status filter can never be silently dropped.
    useEffect(() => {
        fetchComplaints();
    }, [fetchComplaints]);

    // Debounce raw typing into `debouncedSearch`. The fetch above reacts to
    // that committed value.
    useEffect(() => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            setCurrentPage(1);
            setDebouncedSearch(searchTerm.trim());
        }, 800);

        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [searchTerm]);

    // Account-scoped status counts for the summary cards above the table. These
    // honour the same account scope as the list (a DFO sees only their division)
    // plus the active zone/circle/division/date/search filters — but NOT the
    // status filter, so all six cards always reflect the full scoped set.
    const [statusCounts, setStatusCounts] = useState({});
    const [countsTotal, setCountsTotal] = useState(0);
    const [countsLoading, setCountsLoading] = useState(true);

    const fetchStatusCounts = useCallback(async () => {
        try {
            setCountsLoading(true);
            const token = localStorage.getItem('token');
            const params = {};
            if (fromDate) params.from = fromDate;
            if (toDate) params.to = toDate;
            if (selectedZone) params.forestZone = selectedZone;
            if (selectedCircle) params.forestCircle = selectedCircle;
            if (selectedDivision) params.forestDivision = selectedDivision;
            if (debouncedSearch && debouncedSearch.trim()) params.searchQuery = debouncedSearch.trim();
            // On the Informative Calls page, scope the status-tab counts to informative:true
            // so the badges (Resolved, Total, …) reflect informative calls only.
            if (informativeOnly) params.informative = true;
            const res = await axios.get(`${API_BASE_URL}/backend/complaints/complaints-status-count-scoped`, {
                params, headers: { Authorization: `Bearer ${token}` },
            });
            const map = {};
            (res.data?.data || []).forEach((r) => { map[r.status] = r.count; });
            setStatusCounts(map);
            setCountsTotal(res.data?.totalCount || 0);
        } catch (err) {
            setStatusCounts({});
            setCountsTotal(0);
        } finally {
            setCountsLoading(false);
        }
    }, [API_BASE_URL, fromDate, toDate, selectedZone, selectedCircle, selectedDivision, debouncedSearch, informativeOnly]);

    useEffect(() => { if (!embedded && !informativeOnly) fetchStatusCounts(); }, [fetchStatusCounts, embedded, informativeOnly]);

    // Destroy DataTable when using custom pagination
    useEffect(() => {
        if ($.fn.DataTable.isDataTable('#dataTable')) {
            $('#dataTable').DataTable().destroy();
        }
    }, [filteredComplaints]);

    // Search handler - manual trigger commits the search immediately.
    const handleSearch = () => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        setCurrentPage(1);
        setDebouncedSearch(searchTerm.trim());
    };

    const handleClearSearch = () => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        setSearchTerm('');
        setCurrentPage(1);
        setDebouncedSearch('');
    };

    // Load the Zone dropdown once. Circles/Divisions are loaded on demand as
    // the user drills down, so the list stays scoped to the chosen zone.
    useEffect(() => {
        const loadZones = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await axios.get(`${API_BASE_URL}/backend/generic/forestZone`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setForestZones(Array.isArray(res.data?.data) ? res.data.data : []);
            } catch (err) {
                console.error("Error fetching forest zones:", err);
            }
        };
        loadZones();
    }, [API_BASE_URL]);

    // Zone changed -> pull that zone's circles (each circle carries its
    // divisions) and reset everything downstream.
    const handleZoneChange = async (zoneId) => {
        setSelectedZone(zoneId);
        setSelectedCircle('');
        setSelectedDivision('');
        setForestCircles([]);
        setForestDivisions([]);
        setCurrentPage(1);

        if (!zoneId) return;
        const zone = forestZones.find((z) => z._id === zoneId);
        if (!zone) return;

        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(
                `${API_BASE_URL}/backend/districts/get-circles-and-divisions-by-zone`,
                { zone: zone.name },
                { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
            );
            if (res.data?.status) {
                setForestCircles(res.data.circles || []);
            }
        } catch (err) {
            console.error("Error fetching circles and divisions:", err);
            toast.error("Failed to load circles for the selected zone.");
        }
    };

    // Circle changed -> its divisions are already in the circle payload.
    const handleCircleChange = (circleId) => {
        setSelectedCircle(circleId);
        setSelectedDivision('');
        setCurrentPage(1);
        const circle = forestCircles.find((c) => c._id === circleId);
        setForestDivisions(circle?.divisions || []);
    };

    const handleDivisionChange = (divisionId) => {
        setSelectedDivision(divisionId);
        setCurrentPage(1);
    };

    const handleClearForestFilters = () => {
        setSelectedZone('');
        setSelectedCircle('');
        setSelectedDivision('');
        setForestCircles([]);
        setForestDivisions([]);
        setCurrentPage(1);
    };

    // Reset every filter at once (status is driven by the parent/URL and is
    // intentionally left untouched here).
    const handleClearAllFilters = () => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        setSearchTerm('');
        setDebouncedSearch('');
        setFromDate('');
        setToDate('');
        setSelectedZone('');
        setSelectedCircle('');
        setSelectedDivision('');
        setForestCircles([]);
        setForestDivisions([]);
        setCurrentPage(1);
    };

    const hasActiveFilters = Boolean(
        searchTerm || fromDate || toDate || selectedZone || selectedCircle || selectedDivision
    );

    // Update filtered complaints when complaints data changes
    useEffect(() => {
        setFilteredComplaints(complaints);
    }, [complaints]);

    // Rest of your component remains the same...
    const exportToCSV = () => {
        const dataToExport = complaints;
        const csvContent = convertToCSV(dataToExport);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `complaints_page_${currentPage}${searchTerm ? '_search' : ''}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const convertToCSV = (data) => {
        const headers = [
            'Sr #', 'Complaint No', 'Complainant Name', 'Complainant CNIC',
            'Phone Number', 'Secondary Phone', 'Complainant City', 'Complainant District',
            'Nature of Complaint', 'Complaint City', 'Complaint District', 'Nearby Place',
            'Complaint Time', 'Priority Level', 'Referred By', 'Status', 'Received By', 'Assigned To'
        ];

        const rows = data.map((complaint, index) => [
            ((currentPage - 1) * perPage) + index + 1,
            complaint.complaint_number || '',
            complaint.complainant_name || '',
            complaint.complainant_cnic || '',
            complaint.complainant_contact_no || '',
            complaint.complainant_contact_no_sec || '',
            complaint.complainant_city_id?.name || '',
            complaint.complainant_district_id?.name || '',
            complaint.complaint_nature_id?.name || '',
            complaint.complaint_city_id?.name || '',
            complaint.complaint_district_id?.name || '',
            complaint.near_by_place || '',
            new Date(complaint.time_of_call).toLocaleString(),
            complaint.priority_level || '',
            complaint.complaint_reffered_by || '',
            complaint.status || '',
            `${complaint.received_by?.first_name || ''} ${complaint.received_by?.last_name || ''}`,
            `${complaint.assigned_to?.first_name || ''} ${complaint.assigned_to?.last_name || ''}`
        ]);

        return [headers, ...rows].map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
    };
    
    const exportToPDF = () => {
        try {
            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm'
            });
    
            const now = new Date();
            const timestamp = now.toISOString()
                .replace(/T/, '_')
                .replace(/\..+/, '')
                .replace(/:/g, '-');
            const fileName = `Complaints_Page_${currentPage}${searchTerm ? '_search' : ''}_${timestamp}`;
    
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(16);
            doc.text('Complaints Report', 14, 10);
    
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.text(`Generated: ${now.toLocaleString()}`, 14, 15);
            doc.text(`Page ${currentPage} of ${totalPages} | Total Records: ${totalCount}`, 14, 20);
            
            if (searchTerm) {
                doc.text(`Search Term: "${searchTerm}"`, 14, 25);
            }
    
            const headers = [
                'S.L', 'Complaint No', 'Referred By', 'Name', 'CNIC', 'Phone',
                'City', 'District', 'Nature', 'Priority', 'Status'
            ];

            const dataToExport = complaints;
            const pdfData = dataToExport.map((complaint, index) => [
                ((currentPage - 1) * perPage) + index + 1,
                complaint.complaint_number || '',
                complaint.complaint_reffered_by || '',
                complaint.complainant_name || '',
                complaint.complainant_cnic || '',
                complaint.complainant_contact_no || '',
                complaint.complainant_city_id?.name || '',
                complaint.complainant_district_id?.name || '',
                complaint.complaint_nature_id?.name || '',
                complaint.priority_level || '',
                complaint.status || ''
            ]);
    
            autoTable(doc, {
                startY: searchTerm ? 30 : 25,
                head: [headers],
                body: pdfData,
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                    halign: 'left'
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    halign: 'center'
                },
                margin: {
                    top: searchTerm ? 30 : 25,
                    left: 10,
                    right: 10
                }
            });
    
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.text(
                    `Page ${i} of ${pageCount}`,
                    doc.internal.pageSize.width - 20,
                    doc.internal.pageSize.height - 10
                );
            }
    
            doc.save(`${fileName}.pdf`);
        } catch (error) {
            console.error("PDF Export Error:", error);
            toast.error("Failed to generate PDF. Please try again.");
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handlePerPageChange = (e) => {
        setPerPage(parseInt(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = (field) => {
        if (sortingField === field) {
            setSortingOrder(sortingOrder === 'ASC' ? 'DESC' : 'ASC');
        } else {
            setSortingField(field);
            setSortingOrder('ASC');
        }
        setCurrentPage(1);
    };

    const handleDateFilter = () => {
        if (fromDate && toDate) {
            if (new Date(fromDate) > new Date(toDate)) {
                toast.error("From date cannot be greater than To date");
                return;
            }
        }
        setCurrentPage(1);
        fetchComplaints();
    };

    const handleClearDateFilter = () => {
        setFromDate('');
        setToDate('');
        setCurrentPage(1);
    };

    const renderPaginationItems = () => {
        const items = [];
        const maxVisible = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);

        if (endPage - startPage < maxVisible - 1) {
            startPage = Math.max(1, endPage - maxVisible + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            items.push(
                <li key={i} className="page-item">
                    <button
                        className={`page-link fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px ${
                            i === currentPage ? 'bg-primary-600 text-white' : 'bg-base text-secondary-light'
                        }`}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                </li>
            );
        }

        return items;
    };
  
    const handleShowAllDetailsModal = async (complaint) => {
        setSelectedComplaint(complaint);
        setShowAllDetailsModal(true);
    
        const qrCodeData = `${APP_BASE_URL}/complains/view/${complaint._id}`;
        setQrDataUrl(qrCodeData);
        
        try {
            const url = await QRCode.toDataURL(qrCodeData, { width: 100 });
            setQrCodeUrl(url);
        } catch (err) {
            console.error('QR Code generation failed:', err);
        }
    };
    
    const getStatusClasses = (status) => {
        const normalizedStatus = String(status || '').toLowerCase().replace(/\s+/g, '').replace(/-/g, '');
    
        switch (normalizedStatus) {
            case "total":
                return "bg-info-focus text-white";
            case "open":
                return "bg-warning-focus text-warning-600";
            case "inprogress":
                return "bg-info-focus text-info-600";
            case "closed":
                // "Reply Submitted" — sky blue, distinct from Resolved (green)
                // and Re-Open; see .status-reply-submitted in extra.css.
                return "status-reply-submitted";
            case "escalated":
                return "bg-danger-focus text-danger-600";
            case "reopen":
            case "reopened":
            case "Reopened":
                return "bg-light-600 text-dark-1";
            case "cancelled":
                return "bg-danger-focus text-danger-600";
            case "resolved":
                // Was falling through to the default grey-on-grey badge (unreadable).
                return "bg-success-focus text-success-600";
            default:
                return "bg-secondary text-white";
        }
    };
    
    const handleEditComplain = (complaintId) => {
        navigate(`/complains/update/${complaintId}`);
    };
    
    const handleUpdateStatusComplain = (complaintId) => {
        navigate(`/complains/update-status/${complaintId}`);
    };

    const handleViewComplain = (complaintId) => {
        window.open(`/complains/view/${complaintId}`, '_blank', 'noopener');
    };

    // Preserve metadata for preview type detection, including extensionless URLs.
    const renderAttachmentGroup = (title, mediaList) => {
        const items = (Array.isArray(mediaList) ? mediaList : [])
            .filter((media) => /^(https?:\/\/|\/)/i.test(getMediaUrl(media)));
        if (items.length === 0) return null;
        return (
            <div className="col-12 mt-3">
                <h5 className="mb-3"><Icon icon="mdi:paperclip" aria-hidden="true" />{title}<span className="complaint-attachment-count">{items.length}</span></h5>
                <div className="complaint-attachments-grid">
                    {items.map((media, i) => <ComplaintAttachmentPreview key={`${getMediaUrl(media)}-${i}`} media={media} index={i} />)}
                </div>
            </div>
        );
    };
    
    const handleShowDeleteModal = (complaint) => {
        setSelectedComplaint(complaint);
        setShowDeleteModal(true);
    };

    const handleDeleteComplaint = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.patch(
                `${API_BASE_URL}/backend/complaints/delete/${selectedComplaint._id}`,
                {}, 
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                toast.success("Complaint deleted successfully.");
                fetchComplaints();
            } else {
                toast.error("Failed to delete complaint.");
            }
        } catch (error) {
            console.error("Error deleting complaint:", error);
            toast.error("Error deleting complaint.");
        } finally {
            setShowDeleteModal(false);
        }
    };

    const SortIcon = ({ field }) => {
        if (sortingField !== field) return <Icon icon="mdi:sort" className="ms-1" />;
        return sortingOrder === 'ASC' ? 
            <Icon icon="mdi:arrow-up" className="ms-1" /> : 
            <Icon icon="mdi:arrow-down" className="ms-1" />;
    };

    // Calculate display data
    const displayComplaints = complaints;
    const displayCount = totalCount;

    return (
        <div className={`card basic-data-table${embedded ? ' border-0 shadow-none mb-0' : ' complaints-list-panel'}`}>
            {!embedded && <ToastContainer />}

            {/* Account-level status summary — same six statuses as the dashboard,
                but scoped to the data shown in this table. Click a card to filter
                the table by that status (click again to clear). Hidden on the
                Informative Calls page: informative calls are not part of the
                status lifecycle, so a status overview doesn't apply there. */}
            {!embedded && !informativeOnly && (
                <div className="p-16 border-bottom complaints-status-overview">
                    <style>{`
                        .tdl-stat { position: relative; overflow: hidden; width: 100%; text-align: left;
                            border-radius: 14px; padding: 13px 14px 15px;
                            background: linear-gradient(145deg, #ffffff 0%, #eef2f7 100%);
                            border: 1px solid #e2e8f0; border-top-color: #f8fafc; border-bottom-color: #cbd5e1;
                            cursor: pointer;
                            transition: transform .16s ease, box-shadow .16s ease, border-color .16s ease;
                            /* 3D raised bevel: bright top-left highlight + dark bottom-right shadow. */
                            box-shadow: -3px -3px 7px rgba(255,255,255,.9), 4px 5px 12px rgba(15,23,42,.16), inset 0 1px 0 rgba(255,255,255,.6); }
                        .tdl-stat::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; background: var(--acc);
                            box-shadow: 1px 0 3px color-mix(in srgb, var(--acc) 55%, transparent); }
                        .tdl-stat:hover { transform: translateY(-4px);
                            border-color: var(--acc);
                            /* subtle accent border ring that appears on hover */
                            box-shadow: 0 0 0 2px color-mix(in srgb, var(--acc) 45%, transparent), -4px -4px 9px rgba(255,255,255,.95), 8px 12px 22px rgba(15,23,42,.22), inset 0 1px 0 rgba(255,255,255,.7); }
                        .tdl-stat:active { transform: translateY(-1px);
                            box-shadow: inset 2px 3px 7px rgba(15,23,42,.18), inset -2px -2px 6px rgba(255,255,255,.7); }
                        .tdl-stat:focus-visible { outline: none; box-shadow: 0 0 0 3px color-mix(in srgb, var(--acc) 35%, transparent), 4px 5px 12px rgba(15,23,42,.16); }
                        .tdl-stat.is-active { border-color: var(--acc);
                            background: linear-gradient(145deg, #ffffff 0%, color-mix(in srgb, var(--acc) 10%, #eef2f7) 100%);
                            box-shadow: 0 0 0 2px color-mix(in srgb, var(--acc) 32%, transparent), -3px -3px 7px rgba(255,255,255,.9), 5px 8px 16px rgba(15,23,42,.18), inset 0 1px 0 rgba(255,255,255,.6); }
                        .tdl-stat .tdl-ico { width: 34px; height: 34px; border-radius: 10px; display: inline-flex;
                            align-items: center; justify-content: center; background: color-mix(in srgb, var(--acc) 14%, transparent); color: var(--acc); }
                        .tdl-stat .tdl-num { font-size: 22px; font-weight: 800; color: #0f172a; line-height: 1; font-variant-numeric: tabular-nums; }
                        .tdl-stat .tdl-label { font-size: 13px; font-weight: 700; color: #334155; }
                        .tdl-stat .tdl-sub { font-size: 11px; color: #94a3b8; }
                        .tdl-stat .tdl-track { height: 5px; border-radius: 999px; background: #f1f5f9; overflow: hidden; margin-top: 8px; }
                        .tdl-stat .tdl-fill { height: 100%; border-radius: 999px; background: var(--acc); transition: width .5s cubic-bezier(.22,.61,.36,1); }
                        .tdl-stat .tdl-check { position: absolute; top: 8px; right: 8px; color: var(--acc); opacity: 0; transform: scale(.6); transition: .16s; }
                        .tdl-stat.is-active .tdl-check { opacity: 1; transform: scale(1); }
                    `}</style>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="text-secondary-light fw-semibold" style={{ fontSize: 12.5, letterSpacing: '.02em' }}>
                            <Icon icon="mdi:chart-box-outline" className="me-1" />
                            STATUS OVERVIEW · {countsLoading ? '…' : `${countsTotal} complaint${countsTotal === 1 ? '' : 's'} in view`}
                        </span>
                        {statusFilter && statusFilter !== 'Total' && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                                onClick={() => { setStatusChoice(''); setCurrentPage(1); }}
                                style={{ fontSize: 12 }}
                            >
                                <Icon icon="mdi:filter-remove-outline" /> Clear
                            </button>
                        )}
                    </div>
                    <div className="row g-2">
                        {STATUS_SUMMARY_CARDS.map((c) => {
                            const count = statusCounts[c.key] || 0;
                            const pct = countsTotal > 0 ? Math.round((count / countsTotal) * 100) : 0;
                            const active = statusFilter === c.key;
                            return (
                                <div className="col-6 col-md-4 col-xl-2" key={c.key}>
                                    <button
                                        type="button"
                                        aria-pressed={active}
                                        onClick={() => { setStatusChoice(active ? '' : c.key); setCurrentPage(1); }}
                                        className={`tdl-stat h-100${active ? ' is-active' : ''}`}
                                        style={{ '--acc': c.accent }}
                                        title={active ? `Clear ${statusLabel(c.label)} filter` : `Show ${statusLabel(c.label)} complaints`}
                                    >
                                        <Icon icon="mdi:check-circle" className="tdl-check" style={{ fontSize: 16 }} />
                                        <span className="d-flex align-items-center justify-content-between">
                                            <span className="tdl-ico"><Icon icon={c.icon} weight="duotone" style={{ fontSize: 22 }} /></span>
                                            {countsLoading
                                                ? <Skeleton width={28} height={22} />
                                                : <span className="tdl-num">{count}</span>}
                                        </span>
                                        <span className="d-block tdl-label mt-2">{statusLabel(c.label)}</span>
                                        <span className="d-block tdl-sub">{pct}% of total</span>
                                        <div className="tdl-track">
                                            <div className="tdl-fill" style={{ width: `${countsLoading ? 0 : pct}%` }} />
                                        </div>
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* Filters Section */}
            <div className="card-header">
                <div className="complaints-filter-heading">
                        <div><Icon icon="mdi:tune-variant" weight="duotone" aria-hidden="true" /><strong>Refine results</strong></div>
                        <span>Filter by location, keyword or date</span>
                </div>
                <div className="row g-3 complaints-filter-grid">
                    {statusFilter && statusFilter !== 'Total' && (
                        <div className="col-12">
                            <h6 className="mb-0 text-success">
                                {statusFilter} Complaints
                            </h6>
                        </div>
                    )}

                    {/* Status filter — only on the standalone list; the modal is
                        already scoped to a single status via initialStatus. */}
                    {!initialStatus && (
                        <div className="col-md-4">
                            <label className="text-sm fw-medium mb-1 d-block">
                                <Icon icon="mdi:filter-variant" weight="duotone" className="me-1 filter-icon-status" aria-hidden="true" />Status
                            </label>
                            <ComplaintLocationSelect
                                label="Status"
                                value={statusChoice}
                                onChange={(value) => { setStatusChoice(value); setCurrentPage(1); }}
                                options={STATUS_OPTIONS.map((status) => ({ _id: status, name: statusLabel(status) }))}
                                placeholder="All Statuses"
                            />
                        </div>
                    )}

                    {/* Forest location filters — cascading Zone -> Circle -> Division.
                        Each level is disabled until its parent is chosen, and
                        changing a level resets everything below it. */}
                    <div className="col-md-4">
                        <label className="text-sm fw-medium mb-1 d-block">
                            <Icon icon="forest-zone" weight="duotone" className="me-1 filter-icon-zone" aria-hidden="true" />Forest Zone
                        </label>
                        <ComplaintLocationSelect
                            label="Forest zone"
                            value={selectedZone}
                            onChange={handleZoneChange}
                            options={forestZones}
                            placeholder="All Zones"
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="text-sm fw-medium mb-1 d-block">
                            <Icon icon="forest-circle" weight="duotone" className="me-1 filter-icon-circle" aria-hidden="true" />Circle
                        </label>
                        <ComplaintLocationSelect
                            label="Forest circle"
                            value={selectedCircle}
                            disabled={!selectedZone}
                            onChange={handleCircleChange}
                            options={forestCircles}
                            placeholder={selectedZone ? 'All Circles' : 'Select a zone first'}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="text-sm fw-medium mb-1 d-block">
                            <Icon icon="mdi:map-marker" weight="duotone" className="me-1 filter-icon-division" aria-hidden="true" />Division
                        </label>
                        <ComplaintLocationSelect
                            label="Forest division"
                            value={selectedDivision}
                            disabled={!selectedCircle}
                            onChange={handleDivisionChange}
                            options={forestDivisions}
                            placeholder={selectedCircle ? 'All Divisions' : 'Select a circle first'}
                        />
                    </div>

                    {/* Search Bar */}
                    <div className="col-md-8">
                        <label className="text-sm fw-medium mb-1 d-block">
                            <Icon icon="mdi:magnify" weight="duotone" className="me-1 filter-icon-search" aria-hidden="true" />Search
                        </label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <Icon icon="mdi:magnify" />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search across all fields..."
                                aria-label="Search complaints"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
                            />
                            <button
                                className="btn btn-success"
                                onClick={handleSearch}
                            >
                                Search
                            </button>
                            {searchTerm && (
                                <button
                                    className="btn btn-outline-success"
                                    onClick={handleClearSearch}
                                >
                                    Clear
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-end">
                        <button
                            className="btn btn-outline-secondary btn-sm w-100"
                            onClick={handleClearAllFilters}
                            disabled={!hasActiveFilters}
                            title="Reset search, dates and location filters"
                        >
                            <Icon icon="mdi:filter-remove-outline" className="me-1" />
                            Clear All Filters
                        </button>
                    </div>

                    {/* Active filter chips — a quick, removable summary of what's
                        currently narrowing the list. */}
                    {hasActiveFilters && (
                        <div className="col-12">
                            <div className="complaint-active-filters">
                                <span className="text-sm text-muted">Active filters:</span>
                                {selectedZone && (
                                    <span className="complaint-filter-chip">
                                        <span className="complaint-filter-chip-label">Zone</span><span>{forestZones.find((z) => z._id === selectedZone)?.name || '—'}</span>
                                        <button type="button" aria-label="Remove zone filter and dependent location filters" onClick={handleClearForestFilters}><Icon icon="mdi:close" aria-hidden="true" /></button>
                                    </span>
                                )}
                                {selectedCircle && (
                                    <span className="complaint-filter-chip">
                                        <span className="complaint-filter-chip-label">Circle</span><span>{forestCircles.find((c) => c._id === selectedCircle)?.name || '—'}</span>
                                        <button type="button" aria-label="Remove circle and division filters" onClick={() => handleCircleChange('')}><Icon icon="mdi:close" aria-hidden="true" /></button>
                                    </span>
                                )}
                                {selectedDivision && (
                                    <span className="complaint-filter-chip">
                                        <span className="complaint-filter-chip-label">Division</span><span>{forestDivisions.find((d) => d._id === selectedDivision)?.name || '—'}</span>
                                        <button type="button" aria-label="Remove division filter" onClick={() => handleDivisionChange('')}><Icon icon="mdi:close" aria-hidden="true" /></button>
                                    </span>
                                )}
                                {searchTerm && (
                                    <span className="complaint-filter-chip">
                                        <span className="complaint-filter-chip-label">Search</span><span>{searchTerm}</span>
                                        <button type="button" aria-label="Remove search filter" onClick={handleClearSearch}><Icon icon="mdi:close" aria-hidden="true" /></button>
                                    </span>
                                )}
                                {(fromDate || toDate) && (
                                    <span className="complaint-filter-chip">
                                        <span className="complaint-filter-chip-label">Date</span><span>{fromDate || '…'} → {toDate || '…'}</span>
                                        <button type="button" aria-label="Remove date filter" onClick={handleClearDateFilter}><Icon icon="mdi:close" aria-hidden="true" /></button>
                                    </span>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Date Filters and Export Section */}
                    <div className="row g-3 mt-2">
                        <div className="col-12 d-flex justify-content-between align-items-center flex-wrap gap-3">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <div className="d-flex align-items-center gap-2">
                                    <label className="text-sm fw-medium text-nowrap">From:</label>
                                    <input
                                        type="date"
                                        aria-label="From date"
                                        className="form-control form-control-sm"
                                        style={{ width: '150px' }}
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <label className="text-sm fw-medium text-nowrap">To:</label>
                                    <input
                                        type="date"
                                        aria-label="To date"
                                        className="form-control form-control-sm"
                                        style={{ width: '150px' }}
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                </div>
                                <button 
                                    onClick={handleDateFilter} 
                                    className="btn btn-success btn-sm d-flex align-items-center"
                                >
                                    <Icon icon="mdi:filter" className="me-1" style={{ fontSize: '16px' }} />
                                    Apply Dates
                                </button>
                                {(fromDate || toDate) && (
                                    <button 
                                        onClick={handleClearDateFilter} 
                                        className="btn btn-success btn-sm d-flex align-items-center"
                                    >
                                        <Icon icon="mdi:filter-off" className="me-1" style={{ fontSize: '16px' }} />
                                        Clear Dates
                                    </button>
                                )}
                            </div>

                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <div className="d-flex align-items-center">
                                    <label className="me-2 text-sm">Show:</label>
                                    <select 
                                        className="form-select form-select-sm" 
                                        style={{ width: 'auto' }}
                                        value={perPage}
                                        aria-label="Entries per page"
                                        onChange={handlePerPageChange}
                                    >
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <div className="export-buttons d-flex align-items-center">
                                    <button onClick={exportToCSV} className="btn btn-success btn-sm me-2 d-flex align-items-center">
                                        <Icon icon="mdi:file-delimited-outline" className="me-1" style={{ fontSize: '16px' }} /> 
                                        CSV
                                    </button>
                                    <button onClick={exportToPDF} className="btn btn-danger btn-sm d-flex align-items-center">
                                        <Icon icon="mdi:file-pdf-box" className="me-1" style={{ fontSize: '16px' }} /> 
                                        PDF
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card-body">
                <div className="mb-3 text-muted complaints-results-summary" role="status" aria-live="polite">
                    <Icon icon="mdi:format-list-bulleted" className="me-2" aria-hidden="true" />
                    Showing {displayCount ? ((currentPage - 1) * perPage) + 1 : 0} to {Math.min(currentPage * perPage, displayCount)} of <strong>{displayCount}</strong> entries
                    {searchTerm && (
                        <span className="ms-2">(filtered by search: "{searchTerm}")</span>
                    )}
                    {statusFilter && statusFilter !== 'Total' && (
                        <span className="ms-2">(status: {statusFilter})</span>
                    )}
                    {selectedZone && (
                        <span className="ms-2">(zone: {forestZones.find((z) => z._id === selectedZone)?.name})</span>
                    )}
                    {selectedCircle && (
                        <span className="ms-2">(circle: {forestCircles.find((c) => c._id === selectedCircle)?.name})</span>
                    )}
                    {selectedDivision && (
                        <span className="ms-2">(division: {forestDivisions.find((d) => d._id === selectedDivision)?.name})</span>
                    )}
                </div>
                <div className="table-responsive">
                    <table className="table bordered-table mb-0 complaints-records-table" id="dataTable">
                        <colgroup>
                            {[10, 4, 10, 9, 18, 13, 10, 15, 11].map((width, i) => <col key={i} style={{ width: `${width}%` }} />)}
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">Action</th>
                                <th scope="col">Sr #</th>
                                <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('complaint_number')}>
                                    Complaint No <SortIcon field="complaint_number" />
                                </th>
                                <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('time_of_call')}>
                                    Date of Call <SortIcon field="time_of_call" />
                                </th>
                                <th scope="col">Referred By</th>
                                <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('complainant_name')}>
                                    Complainant <SortIcon field="complainant_name" />
                                </th>
                                {/* Complainant CNIC & Phone Number columns removed from the datatable. */}
                                {/* <th scope="col">Secondary Phone</th> */}
                                {/* <th scope="col">Complainant City</th> */}
                                <th scope="col">District</th>
                                <th scope="col">Nature of Complaint</th>
                                
                                <th scope="col" style={{ cursor: 'pointer' }} onClick={() => handleSort('status')}>
                                    Status <SortIcon field="status" />
                                </th>
                                {/* <th scope="col">Received By</th> */}
                                {/* <th scope="col">Assigned To</th> */}
                                {/* <th scope="col">Additional Remarks</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                Array.from({ length: perPage }).map((_, index) => (
                                    <tr key={index}>
                                        <td><Skeleton width={30} /></td>
                                        <td><Skeleton width={30} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={140} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={120} /></td>
                                        <td><Skeleton width={150} /></td>
                                        <td><Skeleton width={100} /></td>
                                        <td><Skeleton width={100} /></td>
                                        {/* One cell per header column (9) so the table
                                            doesn't widen while loading. */}
                                    </tr>
                                ))
                            ) : displayComplaints && displayComplaints.length > 0 ? (
                                displayComplaints.map((complaint, index) => {
                                    const assignedToId = complaint.assigned_to?._id || complaint.assigned_to;
                                    const isAssignedOfficer = Boolean(
                                        loggedInUserId && assignedToId &&
                                        String(loggedInUserId) === String(assignedToId)
                                    );
                                    const canEditComplaint =
                                        complaint.status === 'Open' && hasPermission('complaints', 'edit');
                                    const canUpdateStatus =
                                        isAssignedOfficer &&
                                        ['In Progress', 'Reopened', 'Escalated'].includes(complaint.status) &&
                                        hasPermission('complaints', 'update_status');
                                    const showEditOrStatusButton = canEditComplaint || canUpdateStatus;

                                    return (
                                    <tr key={complaint._id}>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                            {hasPermission('complaints', 'view') && (
                                                <button
                                                    type="button"
                                                    title="View details"
                                                    onClick={() => handleShowAllDetailsModal(complaint)}
                                                    className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                                </button>
                                                )}
                                                {showEditOrStatusButton && (
                                                    <button
                                                        onClick={() => {
                                                            if (canEditComplaint) {
                                                                handleEditComplain(complaint._id);
                                                            } else if (canUpdateStatus) {
                                                                handleUpdateStatusComplain(complaint._id);
                                                            }
                                                        }}
                                                        type="button"
                                                        title={canEditComplaint ? 'Edit complaint' : 'Update status'}
                                                        className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon
                                                            icon={
                                                                canEditComplaint
                                                                    ? 'lucide:edit'
                                                                    : 'lucide:refresh-cw'
                                                            }
                                                            className="menu-icon"
                                                        />
                                                    </button>
                                                )}
                                                {(hasPermission('complaints', 'view') || hasPermission('complaints', 'delete') || (complaint.lat && complaint.long)) && (
                                                    <Dropdown>
                                                        <Dropdown.Toggle as={MoreActionsToggle} title="More actions" />
                                                        <Dropdown.Menu renderOnMount popperConfig={{ strategy: 'fixed' }} className="border-0 shadow-sm radius-12 py-2">
                                                            {hasPermission('complaints', 'view') && (
                                                                <Dropdown.Item onClick={() => handleViewComplain(complaint._id)} className="d-flex align-items-center gap-2 py-2">
                                                                    <Icon icon="lucide:file-text" className="text-secondary-light text-xl" /> Complaint report
                                                                </Dropdown.Item>
                                                            )}
                                                            {complaint.lat && complaint.long && (
                                                                <Dropdown.Item as="a" href={`/dashboard?focusComplaint=${encodeURIComponent(complaint.complaint_number || complaint._id)}`} className="d-flex align-items-center gap-2 py-2">
                                                                    <Icon icon="mdi:map-marker-radius" className="text-warning-600 text-xl" /> View on map
                                                                </Dropdown.Item>
                                                            )}
                                                            {hasPermission('complaints', 'delete') && (
                                                                <>
                                                                    {(hasPermission('complaints', 'view') || (complaint.lat && complaint.long)) && <Dropdown.Divider />}
                                                                    <Dropdown.Item onClick={() => handleShowDeleteModal(complaint)} className="d-flex align-items-center gap-2 py-2 text-danger-600">
                                                                        <Icon icon="fluent:delete-24-regular" className="text-xl" /> Delete complaint
                                                                    </Dropdown.Item>
                                                                </>
                                                            )}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                )}
                                            </div>
                                        </td>
                                        <td>{((currentPage - 1) * perPage) + index + 1}</td>
                                        <td>{complaint.complaint_number || '-'}</td>
                                        <td>{complaint.time_of_call ? new Date(complaint.time_of_call).toLocaleDateString() : '-'}</td>
                                        <td>{complaint.complaint_reffered_by || '-'}</td>
                                        <td>
                                            <span className="complaint-cell-text">{complaint.complainant_name || '-'}</span>
                                        </td>
                                        {/* Complainant CNIC & Phone Number cells removed from the datatable. */}
                                        {/* <td style={{ textAlign: 'center' }}>{complaint.complainant_contact_no_sec || '-'}</td> */}
                                        {/* <td>{complaint.complainant_city_id?.name || '-'}</td> */}
                                        <td>
                                            <span className="complaint-cell-text">{complaint.complainant_district_id?.name || '-'}</span>
                                        </td>
                                        <td>
                                            <span className="complaint-cell-text">{complaint.complaint_nature_id?.name || '-'}</span>
                                        </td>
                                        {/* <td>
                                            <TooltipTextPopupCustom 
                                            text={complaint.complaint_detail}
                                            truncateLength={16} 
                                            placement="right"
                                            customClass="tooltip-info" />
                                        </td> */}
                                        {/* <td>{complaint.complaint_city_id?.name || '-'}</td> */}
                                        {/* <td>{complaint.complaint_district_id?.name || '-'}</td> */}
                                        {/* <td>{complaint.near_by_place || '-'}</td> */}
                                        {/* <td>{new Date(complaint.time_of_call).toLocaleString()}</td> */}
                                        {/* <td>{complaint.priority_level || '-'}</td> */}
                                        {/* <td>{complaint.complaint_source || '-'}</td> */}
                                        
                                        <td>
                                            <span className={`px-16 py-6 rounded-pill fw-semibold text-xs ${getStatusClasses(complaint.status)}`}>
                                                {statusWithLevel(complaint)}
                                            </span>
                                        </td>
                                        {/* <td>
                                            {complaint.received_by?.first_name} {complaint.received_by?.last_name}
                                            {complaint.received_by?.designation ? ` (${complaint.received_by?.designation})` : ''}
                                        </td> */}
                                        {/* <td>
                                            {complaint.assigned_to?.first_name} {complaint.assigned_to?.last_name}
                                            {complaint.assigned_to?.designation ? ` (${complaint.assigned_to?.designation})` : ''}
                                        </td> */}
                                        {/* <td>
                                            <TooltipTextPopupCustom 
                                                text={complaint.remarks}
                                                truncateLength={16} 
                                                placement="left"
                                                customClass="tooltip-info" />
                                        </td> */}
                                    </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        No complaints found against the specified filters.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {displayCount > 0 && (
                    <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3 complaints-pagination">
                        <div className="text-muted">
                            Page {currentPage} of {totalPages}
                        </div>
                        <div className="complaints-pagination-controls">
                            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center mb-0">
                                <li className="page-item">
                                    <button
                                        className="page-link bg-base text-secondary-light fw-medium radius-8 border-0 py-10 px-3 d-flex align-items-center justify-content-center h-48-px"
                                        onClick={() => handlePageChange(1)}
                                        disabled={currentPage === 1 || loading}
                                    >
                                        First
                                    </button>
                                </li>
                                <li className="page-item">
                                    <button
                                        className="page-link bg-base text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1 || loading}
                                    >
                                        <Icon icon="ep:d-arrow-left" className="text-xl" />
                                    </button>
                                </li>
                                {renderPaginationItems()}
                                <li className="page-item">
                                    <button
                                        className="page-link bg-base text-secondary-light fw-medium radius-8 border-0 py-10 d-flex align-items-center justify-content-center h-48-px w-48-px"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages || loading}
                                    >
                                        <Icon icon="ep:d-arrow-right" className="text-xl" />
                                    </button>
                                </li>
                                <li className="page-item">
                                    <button
                                        className="page-link bg-base text-secondary-light fw-medium radius-8 border-0 py-10 px-3 d-flex align-items-center justify-content-center h-48-px"
                                        onClick={() => handlePageChange(totalPages)}
                                        disabled={currentPage === totalPages || loading}
                                    >
                                        Last
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
           
            {/* All Details Modal */}
            <Modal show={showAllDetailsModal} onHide={() => setShowAllDetailsModal(false)} centered size="xl" scrollable className="complaint-details-modal">
            <Modal.Header closeButton className="d-flex flex-column flex-md-row align-items-center p-4">
                <div className="d-flex flex-column flex-md-row align-items-center mb-3 mb-md-0">
                    <img 
                        src={process.env.PUBLIC_URL + "/assets/images/logo_fw.png"}
                        alt="Logo" 
                        className="me-md-4 mb-3 mb-md-0" 
                        style={{ 
                            width: '180px', 
                            height: 'auto',
                            maxWidth: '100%'
                        }} 
                    />
                    <div className="d-flex flex-column align-items-center align-items-md-start">
                        <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-start">
                            <div className="complaint-details-heading">
                                <span className="complaint-details-eyebrow">Complaint overview</span>
                                <Modal.Title className="me-2 mb-2 mb-md-0 text-center text-md-start">
                                    {selectedComplaint?.complaint_number || '-'}
                                </Modal.Title>
                                <span className="complaint-details-subtitle">Forestry &amp; Wildlife Department · Punjab</span>
                            </div>
                            <span className={`px-3 py-1 rounded-pill fw-semibold ${getStatusClasses(selectedComplaint?.status || '')}`}>
                                {selectedComplaint ? statusWithLevel(selectedComplaint) : '-'}
                            </span>
                        </div>
                    </div>
                </div>
                {qrCodeUrl && (
                    <div className="ms-md-auto mt-3 mt-md-0 complaint-qr-block">
                        <a
                            href={qrDataUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Open complaint QR link in a new tab"
                            className="text-decoration-none text-reset"
                        >
                            <div
                                className="qr-code-container"
                                style={{
                                    width: '120px',
                                    height: '120px',
                                    background: 'white',
                                    padding: '8px',
                                    borderRadius: '6px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                    cursor: 'pointer'
                                }}
                            >
                                <img
                                    src={qrCodeUrl}
                                    alt="Complaint QR Code"
                                    style={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                        </a>
                        <span className="complaint-qr-caption">Scan to open</span>
                    </div>
                )}
            </Modal.Header>
            <Modal.Body>
                {selectedComplaint && (
                    <div className="complaint-details-content">
                    <div className="complaint-overview-strip">
                        <div><span><Icon weight="duotone" icon="mdi:flag-outline" aria-hidden="true" /> Priority</span><strong data-priority={selectedComplaint.priority_level}>{selectedComplaint.priority_level || 'Not specified'}</strong></div>
                        <div><span><Icon weight="duotone" icon="mdi:inbox-arrow-down-outline" aria-hidden="true" /> Source</span><strong>{selectedComplaint.complaint_source || 'Not specified'}</strong></div>
                        <div><span><Icon weight="duotone" icon="mdi:map-marker-outline" aria-hidden="true" /> District</span><strong>{selectedComplaint.complaint_district_id?.name || 'Not specified'}</strong></div>
                    </div>
                    <div className="row complaint-details-grid">
                        <div className="col-md-6">
                            <h5 className="mb-3"><Icon weight="duotone" icon="mdi:account-outline" aria-hidden="true" />Complainant Information</h5>
                            <div className="space-y-2">
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:account" /> Name
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_name || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:home" /> Address
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_address || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:phone" /> Phone
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_contact_no || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:phone" /> Secondary Phone
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_contact_no_sec || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:email" /> Email
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_email || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:id-card" /> CNIC
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_cnic || '-'}</span>
                                </div>
                                
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:map" /> Tehsil
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_tehsil_id?.name || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:map-outline" /> District
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complainant_district_id?.name || '-'}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h5 className="mb-3"><Icon weight="duotone" icon="mdi:clipboard-text-outline" aria-hidden="true" />Complaint Information</h5>
                            <div className="space-y-2">
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:office-building" /> Department
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.dept_id?.name || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:alert-circle" /> Nature of Complaint
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complaint_nature_id?.name || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:star" /> Priority Level
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.priority_level || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:source-branch" /> Complaint Source
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complaint_source || '-'}</span>
                                </div>
                                
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:map" /> Complaint Tehsil
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complaint_tehsil_id?.name || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:map-outline" /> Complaint District
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complaint_district_id?.name || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:map-marker" /> Nearby Place
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.near_by_place || '-'}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:home-map-marker" /> Complaint Address
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.complaint_address || '-' }</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:map-marker" /> Coordinates
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.lat != null && selectedComplaint.long != null ? `${selectedComplaint.lat}, ${selectedComplaint.long}` : '-'}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <h5 className="mb-3"><Icon weight="duotone" icon="mdi:text-box-outline" aria-hidden="true" />Complaint Details</h5>
                            <p>{selectedComplaint.complaint_detail || '-'}</p>
                        </div>
                        <div className="col-12 mt-3">
                            <h5 className="mb-3"><Icon weight="duotone" icon="mdi:comment-text-outline" aria-hidden="true" />Complaint Remarks</h5>
                            <p className={!selectedComplaint.remarks ? 'complaint-empty-text' : undefined}>{selectedComplaint.remarks || 'No remarks have been added.'}</p>
                        </div>
                        <div className="col-md-6 mt-3">
                            <h5 className="mb-3"><Icon weight="duotone" icon="mdi:account-check-outline" aria-hidden="true" />Processing Information</h5>
                            <div className="space-y-2">
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:account" /> Received By
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">
                                        {[selectedComplaint.received_by?.first_name, selectedComplaint.received_by?.last_name, selectedComplaint.received_by?.designation ? `(${selectedComplaint.received_by.designation})` : ''].filter(Boolean).join(' ') || '-'}
                                    </span>
                                </div>
                                {selectedComplaint.assigned_to && (
                                    <div className="d-flex justify-content-between">
                                        <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                            <Icon weight="duotone" icon="mdi:account-check" /> Assigned To
                                        </span>
                                        <span className="col-1">:</span>
                                        <span className="col-7 text-decoration-underline">
                                            {[selectedComplaint.assigned_to.first_name, selectedComplaint.assigned_to.last_name, selectedComplaint.assigned_to.designation ? `(${selectedComplaint.assigned_to.designation})` : ''].filter(Boolean).join(' ') || '-'}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
                            <h5 className="mb-3"><Icon weight="duotone" icon="mdi:information-outline" aria-hidden="true" />Additional Information</h5>
                            <div className="space-y-2">
                                <div className="d-flex justify-content-between">
                                    <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                        <Icon weight="duotone" icon="mdi:clock-outline" /> Date of Call
                                    </span>
                                    <span className="col-1">:</span>
                                    <span className="col-7 text-decoration-underline">{selectedComplaint.time_of_call && !Number.isNaN(new Date(selectedComplaint.time_of_call).getTime()) ? new Date(selectedComplaint.time_of_call).toLocaleString() : '-'}</span>
                                </div>
                               {selectedComplaint.complaint_reffered_by && (
                                    <div className="d-flex justify-content-between">
                                        <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                            <Icon weight="duotone" icon="mdi:comment" /> Referred By
                                        </span>
                                        <span className="col-1">:</span>
                                        <span className="col-7 text-decoration-underline">
                                            {selectedComplaint.complaint_reffered_by || '-'}
                                        </span>
                                    </div>
                                )}
                                {selectedComplaint.cancel_reason && (
                                    <div className="d-flex justify-content-between">
                                        <span className="text-success d-flex align-items-center gap-1 col-4 fw-bold">
                                            <Icon weight="duotone" icon="mdi:cancel" /> Cancel Reason
                                        </span>
                                        <span className="col-1">:</span>
                                        <span className="col-7 text-decoration-underline">
                                            {selectedComplaint.cancel_reason || '-'}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {renderAttachmentGroup('Complaint Attachments', selectedComplaint.media_array)}
                        {renderAttachmentGroup('Officer Reply Attachments', selectedComplaint.dfo_reply_media_array)}
                    </div>
                    </div>
                )} 
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowAllDetailsModal(false)}>
                    Close
                </Button>
            </Modal.Footer>
            </Modal>
        
            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete complaint #{selectedComplaint?.complaint_number || '-'}?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteComplaint}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default TableDataLayer;
